import React, { useEffect } from 'react';
import { DateTimeUtils } from 'dyl-components';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import usersActions from "actions/users";
import WebsocketConnection from 'actions/websocket';
import authActions from 'actions/auth/auth';
import subscriptionActions from 'actions/subscription';
import roleActions from 'actions/role';
import { Loader } from 'semantic-ui-react';
import favoritesActions from 'actions/favorites';
import notificationsActions from 'actions/notifications';
import officeViewActions from 'actions/office_view';
import { Phone } from "shared/Softphone/softphone";
import pbx_config from 'actions/pbx_config';
import teamsActions from 'actions/teams';

export const RequireAuth = ({phone, ws}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    
    const { isAuthenticatingUser, userPermissions, productPermissions } = useSelector((state) => {  
        return {
            isAuthenticatingUser: state.auth.isAuthenticatingUser,
            productPermissions: state.subscription.productPermissions,
            userPermissions: state.role.userPermissions
        }
    });

    useEffect(() => {
        const check = async() => {
            const { timezone, temporary_password, isAuthenticated, signed_terms, company_status, access_role_id, customer_id, user_id } = await dispatch(authActions.check()) || {};
            if (temporary_password) {
                navigate('password_reset')
            } else if (isAuthenticated) {
                if (signed_terms === false) {
                    navigate('terms');
                } else {
                    if (timezone) {
                        DateTimeUtils.setTimezone(timezone);
                    }
                    //get productPermissions
                    if(productPermissions.length === 0){
                        dispatch(subscriptionActions.getProductFeatures(customer_id)); 
                    }
                    //get userPermissions
                    if(userPermissions.length === 0){
                        dispatch(roleActions.readUserRoleSet(customer_id, {}, access_role_id));
                    }
                    if (company_status === 'paused') {
                        navigate('/settings/billing/overview');
                    } else {
                        //Phone System
                        dispatch(officeViewActions.browserCreds()).then(creds => {
                            dispatch(pbx_config.phoneStatus('PHONE_STATUS', creds?.hardphone, creds?.softphone, creds?.lead_connect));
                            if (creds.username && ! phone?.current?.config) {
                                phone.current = Phone(creds,{}, {})
                            }
                        })
                        //user Profile
                        dispatch(usersActions.readUserProfile());
                        if (location.pathname?.split("/")[2] === "users") {
                            dispatch(teamsActions.getUserTeams(user_id));
                        }
                        dispatch(favoritesActions.readFavorites());
                        dispatch(notificationsActions.onReadNotificationCenter())
                            .then((data) => {
                                //check if user has new notifications
                                if(data?.notifications.length > 0 && data?.enable_bell ){
                                    dispatch(notificationsActions.hasUnReadNotifications());
                                }
                            })
                    }
                }
            } else {
                navigate('login', {replace: true, state: {from: location}});
            }
        }

        check();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, navigate, location.pathname]);

    return (
    <>
        {(isAuthenticatingUser) 
                ? <Loader size='large' active>Authenticating</Loader> 
                : <Outlet />}
        <WebsocketConnection phone={phone} ws={ws}/>
    </>
    );
}
